import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';

import styles from './styles.module.scss';
import templateStyles from '../../landing-pages/styles.module.scss';

const LearningCenterDetails = ({
  learningCenter,
  onClose,
  plan,
  onSelectLearningCenter,
}) => (
  <Modal size="lg" toggle={onClose} isOpen noFooter>
    <ModalHeader toggle={onClose}>About {learningCenter.title}</ModalHeader>
    <ModalBody className="p-0">
      <section className={styles.header}>
        <div className={styles.container}>
          <div className={styles.row}>
            <div className={styles.image}>
              <img
                src={learningCenter.image_file_name}
                alt={`chosen avatar for ${learningCenter.title}`}
              />
            </div>
            <div className={styles.details}>
              <h1>{learningCenter.title}</h1>
              <h4>
                <FontAwesomeIcon icon="award" className="text-orange" />
                &nbsp;Unyted Certified Educator
              </h4>
              <ul className="list-unstyled">
                {learningCenter.instructor_credentials.map(credential => (
                  <li key={credential}>
                    <FontAwesomeIcon icon="check" className="text-green" />
                    &nbsp;{credential}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>
      <section className={styles.aboutInstructor}>
        <div className={styles.container}>
          <div className={styles.row}>
            <div className={styles.tldrColumn}>
              <h2>About {learningCenter.instructor_first_name}</h2>
            </div>
            <div className={styles.mainColumn}>
              <p className={styles.instructorDescription}>
                {learningCenter.instructor_description}
              </p>
              <blockquote className={styles.instructorQuote}>
                {learningCenter.instructor_quote}
              </blockquote>
            </div>
          </div>
        </div>
      </section>
      <section className={styles.checkOut}>
        <strong>Ready to get started?</strong>
        <span>Click below to purchase {plan.title}!</span>
        <button
          type="button"
          onClick={onSelectLearningCenter}
          className={`btn w-100 w-sm-50 mt-3 ${styles.selectButton}`}
        >
          Purchase Now
        </button>
      </section>
    </ModalBody>
  </Modal>
);

export default LearningCenterDetails;
